import Session from "./Session";
import Config from "./Config";

function getOptions() {
    var headers = new Headers();
    var bearer = "Bearer " + Session.GetAuthenticationToken();

    headers.append("Authorization", bearer);

    var options = {
        method: "GET",
        headers: headers,
        mode: 'cors'
    };

    return options;
}

const ApiClient = {
    GetCostStudies: (searchTerm) => {
        let search = "";
        if (searchTerm) search = `?searchTerm=${searchTerm}`;
        return fetch(`${Config.Provider("api_url")}/CostStudy/AvailableCostStudies/Normal${search}`, getOptions())
            .then((response) => { return response.json(); }).catch(() => { Session.DisplayError();});
    },
    GetAvailableVersions: (studyId) => {
        return fetch(`${Config.Provider("api_url")}/CostStudy/GetAvailableVersions?costStudyId=` + studyId, getOptions())
            .then((response) => { return response.json(); }).catch(() => { Session.DisplayError(); });
    },
    GetCostStudy: (studyId, versionId) => {
        return fetch(`${Config.Provider("api_url")}/CostStudy/CostStudy?costStudyId=` + studyId + "&versionId=" + versionId + "&applyAdjustments=true", getOptions())
            .then((response) => { return response.json(); }).catch(() => { Session.DisplayError();});
    },
    GetCostStudyVersion: (studyId, versionId) => {
        return fetch(`${Config.Provider("api_url")}/CostStudy/CostStudyVersion?costStudyId=${studyId}&versionId=${versionId}`, getOptions())
            .then((response) => response.text())
            .then((url) => {
                return fetch(url).then(response => response.json());
            }).catch(() => { Session.DisplayError(); });
    },
    GetCalculations: (studyId, versionId) => {

        return fetch(`${Config.Provider("api_url")}/Calculation/Calculations?costStudyId=` + studyId + "&versionId=" + versionId, getOptions())
            .then((response) => response.text())
            .then((url) => {
                return fetch(url).then(response => response.json());
            }).catch(() => { Session.DisplayError();});

    },
    GetOverview: (studyId) => {
        return fetch(`${Config.Provider("api_url")}/CostStudy/CostStudyOverview?costStudyId=` + studyId, getOptions())
            .then((response) => response.text())
            .then((url) => {
                return fetch(url).then(response => response.json());
            }).catch(() => { Session.DisplayError();});
    },
    GetSnapshots: (studyId, versionId) => {
        return fetch(`${Config.Provider("api_url")}/CostStudy/CostGroupSnapshots?costStudyId=` + studyId + "&versionId=" + versionId + "&applyAdjustment=true", getOptions())
            .then((response) => response.json())
            .then((urls) => {
                return Promise.all(urls.map(elementUrl => {
                    return fetch(elementUrl, {
                        method: 'GET'
                    })
                    .then(response => response.json());
                }));
            }).catch(() => { Session.DisplayError();});
    }
};

export default ApiClient;